import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'
import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context'

/**
 * Ant Design Vue 全局配置
 * 参考文档: https://www.antdv.com/components/config-provider-cn
 * 
 * 注意：此配置会自动与 vue-i18n 的语言设置联动
 * 当 LanguageSwitcher 组件切换语言时，antdLocale 会自动更新
 */
export const useAntdConfig = () => {
  const { locale } = useI18n()

  // 根据当前语言设置 Ant Design Vue 的 locale
  // 使用 computed 确保响应式更新，当 vue-i18n 的 locale 变化时自动更新
  const antdLocale = computed(() => {
    return locale.value === 'zh' ? zhCN : enUS
  })

  // 主题配置
  const theme: ThemeConfig = {
    token: {
      // 主色
      colorPrimary: '#1890ff',
      // 圆角
      borderRadius: 6,
      // 字体大小
      fontSize: 14,
      // 行高
      lineHeight: 1.5715,
      // 字体家族
      fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
    },
    components: {
      // Button 组件配置
      Button: {
        borderRadius: 6,
      },
      // Input 组件配置
      Input: {
        borderRadius: 6,
      },
      // Select 组件配置
      Select: {
        borderRadius: 6,
      },
      // Table 组件配置
      Table: {
        borderRadius: 6,
      },
      // Card 组件配置
      Card: {
        borderRadius: 8,
      },
    },
  }

  // 全局组件尺寸配置（可选：small | middle | large）
  const componentSize: 'small' | 'middle' | 'large' = 'middle'

  // 方向配置（可选：ltr | rtl）
  const direction: 'ltr' | 'rtl' = 'ltr'

  return {
    antdLocale,
    theme,
    componentSize,
    direction,
  }
}

